import { cfgToThemeContentPath } from '@infinitro/config';
import { createMarkdownIt } from '@infinitro/global';
// Cached by URL so that multiple mounted footer instances (footer-default,
// footer-alternative2, or duplicate mounts of either) share a single
// in-flight/resolved fetch instead of each requesting it separately.
const legalsHtmlCache = new Map();
async function fetchLegalsHtml(url, brandTitle) {
    const response = await fetch(url);
    if (!response.ok)
        throw new Error(`Error fetching content: ${response.statusText}`);
    const text = (await response.text()).replace(/%(domain|brand)%/g, brandTitle);
    const md = await createMarkdownIt({ html: true, breaks: true, linkify: true });
    return md.render(text);
}
/** Loads the footer legals markdown for `locale`, rendered to html, falling back to English. */
export function loadFooterLegalsHtml(locale, brandTitle) {
    const primaryUrl = cfgToThemeContentPath(`/legals/legals.${locale}.md`);
    const fallbackUrl = cfgToThemeContentPath(`/legals/legals.en.md`);
    const cached = legalsHtmlCache.get(primaryUrl);
    if (cached)
        return cached;
    const promise = fetchLegalsHtml(primaryUrl, brandTitle).catch((error) => {
        console.warn('Failed to fetch footer legals:', error);
        return fetchLegalsHtml(fallbackUrl, brandTitle).catch(() => '');
    });
    legalsHtmlCache.set(primaryUrl, promise);
    return promise;
}
